<template>
  <nav class="pagination is-right" role="navigation" aria-label="pagination">
    <ul class="pagination-list">
      <a class="pagination-link" @click="toPage(current - 1)" :disabled="current === 1">&lt;</a>
      <template v-if="current - 1 > 1">
        <a class="pagination-link" @click="toPage(1)">1</a>
        <a class="pagination-link" disabled v-if="current - 2 !== 1">...</a>
      </template>
      <a class="pagination-link" @click="toPage(i)" :class="{ 'is-current': current === i }" v-for="i in range" :key="`pagination-buttons-${i}`">{{ i }}</a>
      <template v-if="current + 1 < total">
        <a class="pagination-link" disabled v-if="current + 2 !== total">...</a>
        <a class="pagination-link" @click="toPage(total)">{{ total }}</a>
      </template>
      <a class="pagination-link" @click="toPage(current + 1)" :disabled="current === total">&gt;</a>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    current: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    onClick: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    range () {
      const min = Math.max(this.current - 1, 1)
      const max = Math.min(this.current + 1, this.total)
      return Array(max - min + 1).fill().map((_, index) => min + index)
    }
  },

  methods: {
    toPage (page) {
      this.$emit('onPageChanged', page)
    }
  }
}
</script>

<style lang="scss">

.pagination {
  margin-top: 2rem;

  .pagination-link {
    background-color: white;
    border-width: 0;
    border-radius: 0;

    &.is-current {
      color: inherit;
      box-shadow: inset 0 -4px 0 0 #00C5FF;
    }

    &:active {
      box-shadow: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue